// OP-3619 — Os rótulos da conferência, por fluxo.
//
// A decisão é a mesma nos dois lados (OK, AVARIADO, SUCATA, NAO_RETORNOU) e o
// código é contrato com o backend — muda o VERBO. Na remessa a peça volta do
// produtor; na transferência ela chega numa praça onde nunca esteve, e
// "voltou" ali é mentira de vocabulário. O conjunto era um só e foi
// reaproveitado sem trocar o verbo.
import { DecisaoConferencia } from '../../../types/estoque'

export type FluxoConferencia = 'RETORNO' | 'CHEGADA'

const ROTULOS: Record<FluxoConferencia, Record<DecisaoConferencia, string>> = {
  RETORNO: {
    OK: 'Voltou em ordem',
    AVARIADO: 'Voltou avariado',
    SUCATA: 'Voltou sem conserto (sucata)',
    NAO_RETORNOU: 'Não voltou (extravio)',
  },
  CHEGADA: {
    OK: 'Chegou em ordem',
    AVARIADO: 'Chegou avariado',
    SUCATA: 'Chegou sem conserto (sucata)',
    NAO_RETORNOU: 'Não chegou (extravio)',
  },
}

/** A ordem é a do domínio: o que fecha bem primeiro, o extravio por último. */
export const DECISOES: DecisaoConferencia[] = ['OK', 'AVARIADO', 'SUCATA', 'NAO_RETORNOU']

export interface OpcaoConferencia {
  decisao: DecisaoConferencia
  rotulo: string
}

export function decisoesDe(fluxo: FluxoConferencia): OpcaoConferencia[] {
  return DECISOES.map((decisao) => ({ decisao, rotulo: ROTULOS[fluxo][decisao] }))
}

/** O rótulo de uma decisão só — a transferência filtra as opções por regime. */
export function rotuloDecisao(fluxo: FluxoConferencia, decisao: DecisaoConferencia | string): string {
  const d = decisao === 'NAO_CHEGOU' ? 'NAO_RETORNOU' : decisao
  return ROTULOS[fluxo][d as DecisaoConferencia] ?? decisao
}
